import { Box } from '@components/Box';
import { Flex } from '@components/Flex';
import { styled } from '@styledComponents';
import { Text } from '@components/typography';
import { ButtonNoneStyled } from '@components/ButtonNoneStyled';
import { themeColor, themeMediaQuery, themeSpace } from '@utils/styledTheme.util';
import { CloudImage } from '@components/CloudImage';

export const StyledReadMore = styled(Flex)`
  gap: ${themeSpace(1)};
  align-items: center;
  .chevron-right-icon {
    margin-top: 5px;
    color: ${themeColor('actionPurple3')};
  }
  cursor: pointer;
`;
export const StyledTitleText = styled(Text)`
  white-space: normal;
`;

export const StyledBox = styled(Box)`
  width: 442px;
  height: 664px;
  border-radius: 0 ${themeSpace(10)} 0 0;
  padding-top: ${themeSpace(9)};
  padding-bottom: ${themeSpace(11)};
  ${themeMediaQuery('below_sm')} {
    padding: ${themeSpace(7)} ${themeSpace(8)};
    padding-bottom: ${themeSpace(9)};
    width: 100%;
    height: auto;
  }
  ${themeMediaQuery('tablet')} {
    width: 100%;
    height: auto;
  }
  ${themeMediaQuery('xl')} {
    width: 650px;
    height: 840px;
  }
`;

export const ImgContainer = styled.div<{ src: string }>`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 170px;
  background-image: ${props => `url(${props.src})`};
  background-size: cover;
  background-position: center center;
  ${themeMediaQuery('below_sm')} {
    height: 438px;
    position: relative;
    left: 0;
    background-position: center bottom;
  }
  ${themeMediaQuery('tablet')} {
    background-position: center center;
  }
`;

export const Container = styled.div`
  position: relative;
  height: 100%;
  margin: 0 100px;
  ${themeMediaQuery('below_sm')} {
    margin: 0 0;
  }
`;

export const TextContainer = styled.div`
  width: 100%;
  left: 0;
  z-index: 10;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  ${themeMediaQuery('below_sm')} {
    position: relative;
    top: 22%;
  }
  ${themeMediaQuery('tablet')} {
    top: 24%;
  }
`;

export const CarouselWrap = styled.div`
  position: relative;
  .slider-list {
    cursor: default !important;
    height: 935px !important;
    ${themeMediaQuery('below_sm')} {
      height: 996px !important;
    }
    ${themeMediaQuery('tablet')} {
      height: 1064px !important;
    }
  }
  .slider-slide {
    :focus {
      outline: none;
    }
    height: 100% !important;
  }
`;

export const SlideButton = styled(ButtonNoneStyled)`
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  height: ${themeSpace(9)};
  width: ${themeSpace(9)};
  background-color: rgba(247, 247, 247, 0.8);
  box-shadow: 0px 7px 16px -8px rgba(0, 0, 0, 0.3), 0px 10px 27px -5px rgba(44, 41, 37, 0.25);
  &:hover svg {
    color: ${themeColor('neutra6')};
  }
  ${themeMediaQuery('below_sm')} {
    height: ${themeSpace(7)};
    width: ${themeSpace(7)};
  }
  ${themeMediaQuery('tablet')} {
    height: ${themeSpace(8)};
    width: ${themeSpace(8)};
  }
`;

export const PreviousSlideButton = styled(SlideButton)`
  margin-left: ${themeSpace(4)};
  ${themeMediaQuery('sm')} {
    margin-left: ${themeSpace(5)};
  }
`;

export const NextSlideButton = styled(SlideButton)`
  margin-right: ${themeSpace(4)};
  ${themeMediaQuery('sm')} {
    margin-right: ${themeSpace(5)};
  }
`;

export const DisplayAboveMobile = styled(Box)`
  display: block;
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;
export const DisplayOnMobile = styled(Box)`
  display: none;
  ${themeMediaQuery('below_sm')} {
    display: block;
  }
`;

export const CarouselIndicatorWrap = styled.div`
  position: absolute;
  bottom: ${themeSpace(9)};
  left: 25px;
  z-index: 10;
  div + div {
    margin-left: ${themeSpace(5)};
  }
  ${themeMediaQuery('below_sm')} {
    bottom: 0;
    left: 33vw;
  }
  ${themeMediaQuery('tablet')} {
    bottom: 0;
    left: 41vw;
  }
`;

export const Inactive = styled.div`
  cursor: pointer;
  width: ${themeSpace(4)};
  height: ${themeSpace(4)};
  border: 2px solid ${themeColor('purple4')};
  border-radius: 50%;
`;

export const Active = styled.div`
  cursor: pointer;
  width: ${themeSpace(4)};
  height: ${themeSpace(4)};
  border: 1px solid ${themeColor('purple4')};
  border-radius: 50%;
  background: ${themeColor('purple4')};
`;

export const ProductGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 122px);
  row-gap: ${themeSpace(6)};
  margin-top: ${themeSpace(7)};
  ${themeMediaQuery('below_sm')} {
    grid-template-columns: repeat(3, 33%);
  }
  ${themeMediaQuery('tablet')} {
    gap: ${themeSpace(7)} 0;
  }
  ${themeMediaQuery('xl')} {
    gap: ${themeSpace(7)} ${themeSpace(10)};
  }
`;

export const ProductGridItem = styled(ButtonNoneStyled)`
  display: flex;
  align-items: center;
  cursor: pointer;
  ${themeMediaQuery('tablet')} {
    justify-content: center;
    width: 140px;
    height: 140px;
    gap: ${themeSpace(8)} ${themeSpace(5)};
  }
`;

export const ProductImage = styled(CloudImage)`
  width: 90px;
  height: 90px;
  border-radius: ${themeSpace(3)};
  box-shadow: 0px 30px 60px -12px rgba(44, 41, 37, 0.25), 0px 18px 36px -18px rgba(0, 0, 0, 0.3);
  ${themeMediaQuery('below_sm')} {
    width: 80px;
    height: 80px;
  }
  ${themeMediaQuery('tablet')} {
    width: 140px;
    height: 140px;
  }
  ${themeMediaQuery('xl')} {
    width: 130px;
    height: 130px;
  }
`;

export const StyledUserStory = styled(Text)`
  max-height: 189px;
  overflow: hidden;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-line-clamp: 6;
  -webkit-box-orient: vertical;
  margin: 0 0 ${themeSpace(1)} 0;
  margin-bottom: ${themeSpace(1)};
`;
